import React from 'react';

import { css } from '@emotion/react';
import { Modal, Type } from '@robinhood/design';
import { ModalWidth } from '@robinhood/design/product/components/Modal';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  title: string;
  description: string;
  visible: boolean;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick?: () => void;
  onClose?: () => void;
  variant?: ModalWidth;
}

const AlertModal = ({
  title,
  description,
  visible,
  variant = 'standard',
  primaryButtonLabel = 'Dismiss',
  secondaryButtonLabel,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onClose,
}: PropsIface) => {
  if (!visible) return null;
  return (
    <Modal width={variant} overrideModalStyles={root} onClose={onClose}>
      <Type.Display size='S' overrideRootStyles={{ textAlign: 'center' }}>
        {title}
      </Type.Display>
      <Type.Text size='M' overrideRootStyles={{ textAlign: 'center' }}>
        {description}
      </Type.Text>
      <div css={buttonContainer}>
        <Button label={primaryButtonLabel} width='full' type='button' onClick={onPrimaryButtonClick} />
        {onSecondaryButtonClick && secondaryButtonLabel && (
          <Button
            variant='secondary'
            label={secondaryButtonLabel}
            width='full'
            type='button'
            onClick={onSecondaryButtonClick}
          />
        )}
      </div>
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default AlertModal;
